import { Api } from "../helpers";

export const answerService = {
  getList,
  createAnswer
};

// get the list of all accept protools
// {state: 'all}
function getList(options) {
  console.log({ options })
  return Api()
    .get("/answers/all", { params: options })
    .then(response => {
      // returns list of questions
      return response.data.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// create new answer, pass data
function createAnswer(options) {
  return Api()
    .post("/answer", options.data)
    .then(response => {
      // return accept-protocol by id
      // {id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1,…}
      return response.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
